














import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'

@Component
export default class SwitchBtn extends Vue {
    @Prop({default: 0}) value!: any

    @Prop({default: '#53B96E'}) activeBg!: string

    @Prop({default: ''}) activeText!: string

    @Prop({default: ''}) inactiveText!: string

    @Prop({default: 1}) activeValue!: any

    @Prop({default: 0}) inactiveValue!: any

    @Prop({default: false}) disabled!: boolean

    change() {
        if (!this.disabled) {
            let val = this.value === this.activeValue ? this.inactiveValue : this.activeValue
            this.$emit('input', val)
            this.$emit('change', val)
        }
    }
}
